import React, {Fragment, useEffect, useRef, useState} from 'react'
import axios, * as others from 'axios';
import {useLoaderData, useLocation, useParams} from "react-router-dom";
import {
    addEventAttribute,
    adminEventCard,
    audienceButtons,
    changeAttribute,
    copyButton,
    copyTextToClipboard, eventHeadCard,
    getAttribute,
    getImageWithPrefix,
    getLocalDate,
    getSite,
    hasAttribute,
    inheritAudiences,
    isUrlValid,
    manageAttractionData,
    mergeEvents,
    mergeEventsCard,
    MetaTags,
    setAttribute,
    setRoomAttribute,
    setUniqueAttractionAttribute,
    setUniqueEventAttribute,
    smallArtistCard,
    smallEventCard,
    smallVenueCard,
    toastSuccess,
    urlfriendly,
    workingWithCard,
    workingWithCardPlusEdit
} from "../../components/common/utilities";
import ContentEditable from "react-contenteditable";
import PropertyNavigation from "../../components/common/navigation.component";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import MainNavigation from "../../components/common/navigation.component";
import {DateTimePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import 'moment/locale/en-gb';
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import MediaCollection from "../media/mediaCollection";
import {Dialog, Field, Label, Switch, Transition} from "@headlessui/react";
import {ToastContainer} from "react-toastify";
import ListAttractions from "../attractions/listAttractions";
import FindAttractions from "../attractions/findAttractions";
import FindVenues from "../venues/findVenues";
import {XMarkIcon} from "@heroicons/react/24/outline";
import EditDescriptions from "../../components/common/editdescriptions";
import {SchemaEvent} from "../../components/common/dataTypes";
import PromoteEvent from "../../components/common/promoteEvent";
import EventStatistics from "../../components/common/eventStatistics";
import {XCircleIcon} from "@heroicons/react/16/solid";
import PromoteEventLoggedIn from "../../components/common/promoteEventLoggedIn";
import PromoteEventSpecial from "../../components/common/promoteEventSpecial";
import EditRequest from "../authentication/canEdit";

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function ViewEvent() {
    let params = useParams();
    const venueID = params.venueID;
    const data = useLoaderData() as any;
   // console.log("params", params);

    const text = useRef("");
    const inFocus = useRef("");
    const [artists, setArtists] = useState(data.artists);
    const [duplicates, setDuplicates] = useState([]);
    let [loading, setLoading] = useState(true);
    let [color, setColor] = useState("#ffffff");
    const [date, setDate] = useState(null)
    const [eventData, setEventData] = useState<SchemaEvent>();
    const [showMedia, setShowMedia] = useState(false);
    const [artistSearch, setArtistSearch] = useState(false);
    const [venueSearch, setVenueSearch] = useState(false);
    const [showDescriptions, setShowDescriptions] = useState(false);
    const [removingAttractions, setRemovingAttractions] = useState(false);
    const [changeVenue, setChangeVenue] = useState(false);
    const [offers, setOffers] = useState([]);
    const [wholeDay, setWholeDay] = useState(false);
    const [isPrivate, setIsPrivate] = useState(false);
    const [lang, setLang] = useState(getLang());
    const [open, setOpen] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [editRequests, setEditRequests] = useState([]);
    const [showSpecial, setShowSpecial] = useState(false);


    function getLang()
    {
        const userlang = localStorage.getItem('userlang');
        if (userlang)
        {
            return userlang;
        }
        if (navigator.languages != undefined) return navigator.languages[0];
        return navigator.language;
    }

    let adBtnGroupClasses = classNames('relative inline-flex items-center rounded-l-md px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'
        , {});

    const getEvent = () => {

        const now = new Date();

        let parameters = {
            event: params.eventid,
            tiny: true,
            lang: lang,
            date: now.toISOString(),
        };
        if (data.isAdmin)
        {
            parameters['admin'] = true;
        }

        // /v1/event/`+params.eventid
        // /p/manage/event.do

        const serverName = window.location.hostname;
        let apipath = "/v1/event/"+params.eventid+"/"+lang;


        axios.get(`${process.env.REACT_APP_CLOUDAPI_URL}`+apipath, {
            params: parameters

        }).then(function (response) {
            // handle success
            //console.log(response);
            setEventData(response.data)
            if (response.data.performers)
            {
                setArtists(response.data.performers);
            }
            else if (response.data.performer)
            {
                setArtists(response.data.performer);
            }
            if (response.data.gogo && response.data.gogo.wholeDay)
            {
                setWholeDay(response.data.gogo.wholeDay);
            }
            if (response.data.admin && response.data.admin.isprivate)
            {
                setIsPrivate(response.data.admin.isprivate);
            }
            if(response.data.offers)
            {
                let offer = null;
                if (Array.isArray(response.data.offers)) {
                    console.log("It's a list of objects:", response.data.offers);
                    offer = response.data.offers[0];
                    setOffers(response.data.offers);


                } else if (typeof response.data.offers === 'object' && response.data.offers !== null) {
                    console.log("It's a single object:", response.data.offers);
                    setOffers(response.data.offers);
                    offer = response.data.offers;

                } else {
                    console.log("It's something else:", response.data.offers);
                }

                console.log("offer", offer.price);
                //console.info("tier",response.data.location.gogo.tier)
                if(response.data.location && response.data.location.gogo && response.data.location.gogo.tier && response.data.location.gogo.tier === 5)
                {
                    setShowSpecial(true);
                }
                else if(offer.price && offer.price < 5000)
                {
                    setShowSpecial(true);
                }
                else if (!offer.price)
                {
                    if(offer.lowPrice && offer.lowPrice < 5000)
                    {
                        setShowSpecial(true);
                    }
                    else if (offer.lowPrice && offer.lowPrice > 4999)
                    {

                        setShowSpecial(false);

                    }
                    else {
                        setShowSpecial(true);
                    }

                }
            }
            else {
                setShowSpecial(true);
            }
            adBtnGroupClasses = classNames('relative inline-flex items-center rounded-l-md px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10', {
                'bg-green-500': eventData.gogo && eventData.gogo.ad,
                'text-white': eventData.gogo && eventData.gogo.ad,
                'bg-white': !eventData.gogo || !eventData.gogo.ad,
                'text-gray-900': !eventData.gogo || !eventData.gogo.ad,
            });

        }).catch(function (error) {
            // handle error
            console.log(error);
            //window.location.href = '/dashboard';
        });
    }


    const getEvents = nextOffset => {
        axios.get(`${process.env.REACT_APP_API_URL}/p/events/upcoming.do`, {
            params: {
                instance: 'promogogo', ticket: localStorage.getItem('ticket'), //guid: params.id,
                limit: 10, offset: nextOffset, artist: params.id,
            }

        }).then(function (response) {
            // handle success
            console.log("events", response);
            //setRooms(response.data.collection);

        });
    }
    const getDuplicates = async () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/event/duplicates.do`, {
            ticket: localStorage.getItem('ticket'),
            event: params.eventid,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            if(response.data.collection && response.data.collection.length > 1)
            {
                setDuplicates(response.data.collection);
            }

        });
    }

    const getEditRequests = async () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/claimlist.do`, {
            ticket: localStorage.getItem('ticket'),
            event: params.eventid,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            if(response.data && response.data.length > 0)
            {
                setEditRequests(response.data);
            }

        });
    }

    const requestEdit = async () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/claim.do`, {
            ticket: localStorage.getItem('ticket'),
            event: params.eventid,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            if(response.data.success)
            {
                toastSuccess("Request sent");
            }

        });
    }

    const getEditability = async () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/event/canedit.do`, {
            ticket: localStorage.getItem('ticket'),
            event: params.eventid,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            if(response.data.canedit)
            {
                setCanEdit(true);
            }

        });
    }

    const handleEditPrivileges = (guid,email) => {


        setUniqueEventAttribute("requestEdit", guid, true, true, params.eventid);
        setUniqueEventAttribute(guid, email, true, true, params.eventid);
        setUniqueEventAttribute("canEdit", guid, false, false, params.eventid);

        toastSuccess('Event updated');
    }

    const toggleMedia = () => {
        if (showMedia)
        {
            setShowMedia(false);
        }
        else
        {
            setShowMedia(true);
        }
    }

    const searchVenues = () => {
        setOpen(true);
        setVenueSearch(true);
        setArtistSearch(false);
        setShowDescriptions(false);

    }

    const searchAttractions = () => {
        setOpen(true);
        setVenueSearch(false);
        setArtistSearch(true);
        setShowDescriptions(false);

    }

    const editDescriptions = () => {
        setOpen(true);
        setVenueSearch(false);
        setArtistSearch(false);
        setShowDescriptions(true);
    }


    useEffect(() => {
        getEditability();
        getEvent();
        getDuplicates();
        getEditRequests();
        //getPhotos();
        //handleArtists(data);

    }, []);

    const copyDescription = (artist,lang) => {
        let artistID = artist['@id'];
        let description = eventData.description;
        let key = 'description-html-'+lang;
        if(artistID && description)
        {

            setUniqueAttractionAttribute(key,description,true,false,artistID);
            toastSuccess("set description-"+lang+" for "+artist.name)
        }

    }

    const pagedata = useLoaderData() as any;
    let faceguid = '';

    const handleImageURL = e => {
        var imageurl = e.target.value;
        if (imageurl.length > 4 && !isUrlValid(imageurl))
        {
            toastSuccess("URL is invalid");

            return;
        }
        console.log('handle imageurl: ', e.target.value);
        let key = "setPhoto";
        let value = imageurl;
        let unique = true;
        let remove = false;
        let eventid = eventData['@id'];

        setUniqueEventAttribute(key, value, unique, remove, eventid);

        toastSuccess('Event updated');


        //console.log(text.current);
        //setAttribute(data['guid'], e.target.id, document.getElementById(e.target.id).textContent, true, false);
    };

    function clickedEvent(e)
    {
        console.log("clicked", e.target);

        let button = e.target.dataset.button;
        if (button === 'mediaSelected')
        {
            console.log('settingMedia');
            let media = e.target.dataset.media;
            setEventData({
                             ...eventData, image: media
                         });


            let key = "setPhoto";
            let value = e.target.dataset.media;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = eventData['@id'];

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event updated');

        }
        else if (button === 'editAttraction')
        {
            console.log('addingAttraction');
            let media = e.target.dataset.media;
            let key = "addAttraction";
            let value = e.target.dataset.attractionid;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = eventData['@id'];

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event updated');
            setTimeout(getEvent,3000);

        }
        else if (button === 'clickedAttraction')
        {
            let media = e.target.dataset.media;
            let key = "addAttraction";
            let value = e.target.dataset.attractionid;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = eventData['@id'];

            if (removingAttractions)
            {
                console.log('removingAttraction');
                setUniqueEventAttribute(key, value, true, true, eventid);
                toastSuccess('Removing Performer');

            }
            else
            {
                window.open('/attraction/' + value, '_blank')
            }


            //setUniqueEventAttribute(key,value,unique,remove,eventid);


        }
        if (button === 'setAd')
        {
            console.log('setAd');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event updated');

        }
        if (button === 'removeAd')
        {
            console.log('removeAd');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = true;
            let remove = true;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event updated');

        }

        else if (button === 'setPrivate')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event set to private');

        }

        else if (button === 'manageAudience')
        {
            console.log('managing audience');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = true;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute('pgg.audience.' + key, 'pgg.audience.' + value, unique, remove, eventid);

            toastSuccess('Audience set ' + key + ' Remove: ' + remove);

        }
        else if (button === 'editVenue')
        {
            console.log('addingAttraction');
            let key = "setVenue";
            let value = e.target.dataset.venueid;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = eventData['@id'];

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event updated');
            setTimeout(getEvent,3000);

        }
        else if (button === 'copyDescription')
        {
            let artistID = e.target.dataset.artistid;
            let description = eventData.description;
            let key = 'description-html-'+e.target.dataset.lang;
            if(e.target.dataset.lang === 'default')
            {
                key = 'description-html';
            }
            if(artistID && description)
            {

                setUniqueAttractionAttribute(key,description,true,false,artistID);
                toastSuccess("set description-"+e.target.dataset.lang+" for "+artistID)
            }
        }
        else if (button === 'mergeEvent')
        {
            let otherEventID = e.target.dataset.eventid;
            let eventid = eventData['@id'];

            mergeEvents(eventid,otherEventID);
            toastSuccess("Merged events");

        }

        else if (button === 'mergeWithThatEvent')
        {
            let otherEventID = e.target.dataset.eventid;
            let eventid = eventData['@id'];

            mergeEvents(otherEventID,eventid);
            toastSuccess("Merged events");

        }
        if (button === 'inheritAudience')
        {
            let eventid = eventData['@id'];
            let inheritartist = e.target.dataset.inheritartist;
            inheritAudiences(null,eventid,inheritartist);

            toastSuccess('set audience');
        }

    }

    const changeName = (e) => {
        e.preventDefault();
        console.log(e);
        let value = e.target.value.value;
        console.log('changing name to ', value);
        let tempData = eventData;

        setEventData({
                         ...tempData, name: value
                     });
        setUniqueEventAttribute('eventTitle', value, true, false, eventData['@id']);

    }

    const setPurchaseURL = (e) => {
        e.preventDefault();
        console.log('setting private');
        let key = "purchaseURL";
        let value = e.target.value.value;
        let unique = true;
        let remove = false;
        if(value.length < 1)
        {
            remove = true;
        }
        let eventid = eventData['@id'];

        setUniqueEventAttribute(key, value, unique, remove, eventid);

        toastSuccess('Purchase URL set');
    }

    const changeType = (e) => {
        e.preventDefault();
        let value = e.target.value;
        console.log('changing type to ', value);
        setUniqueEventAttribute('attractiontype', value, true, false, eventData['@id']);
    }

    function changeStartDate(e)
    {
        console.log(moment.utc(e._d).format('yyyy-MM-DD HH:mm'));
        let start = moment.utc(e._d).format('yyyy-MM-DD HH:mm');
        setEventData({
                         ...eventData, localStartDate: start, startDate: start
                     })
        setUniqueEventAttribute("localStart", start, true, false, eventData['@id']);

    }

    function changeEndDate(e)
    {
        console.log(e);
        console.log(moment.utc(e._d).format('yyyy-MM-DD HH:mm'));
        let end = moment.utc(e._d).format('yyyy-MM-DD HH:mm');
        setEventData({
                         ...eventData, localEndDate: end, endDate: end
                     })
        setUniqueEventAttribute("localEnd", end, true, false, eventData['@id']);

    }


    const createEvent = (e) => {
        e.preventDefault();
        console.log(e);

        console.log('posting ', eventData);
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/event/create.do`, eventData, {
            headers: {
                'ticket': localStorage.getItem('ticket'),
            }
        }).then(function (response) {
            // handle success
            console.log(response);
            setEventData(response.data);
            //setOpen(false);
            //setRooms(response.data.collection);
            //window.location.href = '/onboarding/room/'+response.data.collection[0]['guid'];

        });
    }

    const saveEvent = (changedData) => {
        console.log('posting ', changedData);
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/event/create.do`, changedData, {
            headers: {
                'ticket': localStorage.getItem('ticket'),
            }
        }).then(function (response) {
            // handle success
            console.log(response);
            setEventData(response.data);
            //setOpen(false);
            //setRooms(response.data.collection);
            //window.location.href = '/onboarding/room/'+response.data.collection[0]['guid'];

        });
    }



    return (

        <div className="min-h-full dark:bg-white bg-white">
            {eventData && <MetaTags
                title={'EV: '+eventData.name}
                description={eventData.description}
                image={eventData.image && getImageWithPrefix(eventData.image)} />
                }

            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40" onClose={setOpen}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-2">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-4xl">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                                            <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll overflow-x-hidden py-1">
                                                <div className="px-2 sm:px-6">
                                                    <div className="flex items-start justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-gray-900">
                                                            Action Pane
                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="relative rounded-md bg-red-700 text-white hover:bg-red-500 hover:outline-none hover:ring-2 hobver:ring-red-500"
                                                                onClick={() => setOpen(false)}
                                                            >
                                                                <span className="absolute -inset-2.5"/>
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                                    {artistSearch &&
                                                     <div onClick={(event) => clickedEvent(event)}>
                                                         {eventData && <div className={'p-1 text-xs text-gray-900'} dangerouslySetInnerHTML={{__html:eventData.description}}></div>}
                                                         <FindAttractions merge={false} limit={20}
                                                                                                                    venueData={null}/>
                                                     </div>}
                                                    {venueSearch &&
                                                     <div onClick={(event) => clickedEvent(event)}><FindVenues merge={false} limit={20}
                                                                                                               venueData={null}/>
                                                     </div>}
                                                    {showDescriptions && <EditDescriptions theData={eventData} event={eventData['@id']} artist={false} venue={false}/>}

                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                                                    onClick={() => setOpen(false)}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            <SidebarNavigation/>
            <div className="lg:pl-72">

                <main>
                    {!eventData && <div className="p-4 text-gray-800 flex justify-center">
                        <div className={'text-pg_yellow'}><i
                                className="fa-2x fa-duotone fa-loader fa-spin"></i></div>
                    </div>}
                    {eventData && <>
                    <div className="md:grid md:grid-cols-3">
                        <div className="col-span-2">
                            <div className="mt-2">
                                {!canEdit && <>
                                    {eventHeadCard(eventData)}

                                    <div className="rounded-md p-2 bg-red-50 border border-red-700 m-2">
                                    <div className="flex">
                                        <div className="shrink-0">
                                            <XCircleIcon aria-hidden="true" className="size-5 text-red-400" />
                                        </div>
                                        <div className="ml-3">
                                            <h3 className="text-sm font-medium text-red-800">You do not have permission to edit this event</h3>
                                        </div>
                                    </div>
                                </div></>}

                                {!canEdit && (<>
                                    <EditRequest params={data} eventid={eventData['@id']} artistid={null} venueid={null} />

                                </>)}


                                {canEdit && eventData && <>
                                    <div className="">
                                        <div className="md:px-4 py-5 sm:p-6">

                                            <div className=" px-4 sm:mt-16 sm:px-0 lg:mt-0">
                                                <form onSubmit={e => changeName(e)}>
                                                    <label htmlFor="value"
                                                           className="text-1xl font-bold tracking-tight text-gray-900">
                                                        Title
                                                    </label>
                                                    <div className="mt-2 flex rounded-md shadow-sm h-10">
                                                        <div
                                                                className="relative flex flex-grow items-stretch focus-within:z-10">
                                                            <div
                                                                    className="p-2 pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">

                                                            </div>
                                                            <input
                                                                    type="text"
                                                                    name="value"
                                                                    id="value"
                                                                    className="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600  text-3xl font-bold tracking-tight text-gray-900"
                                                                    defaultValue={eventData.name}
                                                            />
                                                        </div>
                                                        <button
                                                                type="submit"
                                                                className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                        >

                                                            Save
                                                        </button>
                                                    </div>

                                                </form>
                                                <div onClick={(event) => clickedEvent(event)}>
                            <span className="isolate inline-flex rounded-md shadow-sm">
                    {eventData.gogo && eventData.gogo.ad === 'true' && (<>
                        <button
                            type="button"
                            className={'relative inline-flex items-center rounded-l-md px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 bg-pg_green text-white hover:bg-pg_purple focus:z-10'}
                            data-button={'removeAd'} data-key={'gjuggad'} data-value={'true'} data-unique={true}
                            data-remove={true} data-eventid={eventData['@id']}
                            title={'Remove ad'}

                        >
                            <i className="fa-duotone fa-billboard" data-button={'removeAd'} data-key={'gjuggad'}
                               data-value={'true'} data-unique={true}
                               data-remove={true} data-eventid={eventData['@id']}></i>
                        </button>
                    </>)}{!eventData.gogo || !eventData.gogo.ad && (<>
                                <button
                                    type="button"
                                    className={adBtnGroupClasses}
                                    data-button={'setAd'} data-key={'gjuggad'} data-value={'true'}
                                    data-unique={true}
                                    data-remove={false} data-eventid={eventData['@id']}
                                    title={'Set as ad'}
                                >
                                    <i className="fa-duotone fa-billboard" data-button={'setAd'} data-key={'gjuggad'}
                                       data-value={'true'}
                                       data-unique={true}
                                       data-remove={false} data-eventid={eventData['@id']}></i>
                                </button>
                            </>)}

                                <button
                                        type="button"
                                        onClick={() => copyTextToClipboard('https://gjugg.is/event/' + urlfriendly(eventData.name) + '/' + eventData['@id'])}
                                        className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                        title={'Copy link'}
                                >

        <i className="fa-solid fa-copy"></i>&nbsp;G
      </button> <button
                                    type="button"
                                    onClick={() => copyTextToClipboard('https://mobilitus.is/event/' + urlfriendly(eventData.name) + '/' + eventData['@id'])}
                                    className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                    title={'Copy link'}
                            >

        <i className="fa-solid fa-copy"></i>&nbsp;M
      </button> <button
                                    type="button"
                                    onClick={() => copyTextToClipboard('https://visir.is/vidburdir/?event='+eventData['@id']+'#event/')}
                                    className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                    title={'Copy link'}
                            >

        <i className="fa-solid fa-copy"></i>&nbsp;V
      </button>
                                {eventData.admin && eventData.admin.isprivate && (<button
                                    type="button"
                                    className="relative -ml-px inline-flex items-center bg-red-700 px-3 py-2 text-sm font-semibold text-white ring-1 ring-inset ring-gray-300 hover:bg-red-400 hover:text-white focus:z-10"
                                    data-button={'setPrivate'}
                                    data-key={'setprivate'}
                                    data-value={'true'}
                                    data-unique={true}
                                    data-remove={false}
                                    data-eventid={eventData['@id']}
                                    title={'Make event public'}

                                ><i className="fa-duotone fa-eye-slash" data-button={'setPrivate'}
                                    data-key={'setprivate'} data-value={'true'}
                                    data-unique={true}
                                    data-remove={false} data-eventid={eventData['@id']}></i>
                                </button>)}

                                {eventData.admin && !eventData.admin.isprivate && (<button
                                    type="button"
                                    className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                    data-button={'setPrivate'} data-key={'setprivate'} data-value={'false'}
                                    data-unique={false}
                                    data-remove={false} data-eventid={eventData['@id']}
                                    title={'Make event private'}

                                ><i className="fa-duotone fa-eye" data-button={'setPrivate'} data-key={'setprivate'}
                                    data-value={'false'}
                                    data-unique={true}
                                    data-remove={true} data-eventid={eventData['@id']}></i>


                                </button>)}
                                {!eventData.admin && (<button
                                    type="button"
                                    className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                    data-button={'setPrivate'} data-key={'setprivate'} data-value={'false'}
                                    data-unique={false}
                                    data-remove={false}
                                    data-eventid={eventData['@id']}
                                    title={'Make event private'}

                                ><i className="fa-duotone fa-eye" data-button={'setPrivate'} data-key={'setprivate'}
                                    data-value={'false'}
                                    data-unique={true}
                                    data-remove={false} data-eventid={eventData['@id']}></i>


                                </button>)}

                                <button
                                        type="button"
                                        onClick={() => window.open(`${process.env.REACT_APP_API_URL}/go/promogogo/createmoment.do?event=` + eventData['@id'], '_blank')}
                                        className="relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                        title={'Edit event'}
                                >
        <i className="fa-duotone fa-pen-to-square"></i>
      </button>




    </span>
                                                    <div className={'mt-2'}>
                                <span className="isolate inline-flex rounded-md shadow-sm">
                                {eventData.gogo && eventData.gogo.majorType && eventData.gogo.majorType === 'music' && (<>
                                    <button
                                        type="button"
                                        className={'relative -ml-px rounded inline-flex items-center bg-red-700 px-3 py-2 text-sm font-semibold text-white ring-1 ring-inset ring-gray-300 hover:bg-green-400 hover:text-white focus:z-10'}
                                        data-button={'setAttractionType'} data-key={'attractionType'}
                                        data-value={'community'}
                                        data-unique={true}
                                        data-remove={false} data-eventid={eventData['@id']}
                                        title={'Set as community event'}

                                    >
                                        <i className="fa-solid fa-people-arrows" data-button={'setAttractionType'}
                                           data-key={'attractionType'}
                                           data-value={'community'}
                                           data-unique={true}
                                           data-remove={false} data-eventid={eventData['@id']}></i>
                                    </button>
                                </>)}{eventData.gogo && eventData.gogo.majorType && eventData.gogo.majorType !== 'music' && (<>
                                    <button
                                        type="button"
                                        className={'relative -ml-px rounded inline-flex items-center bg-green-700 px-3 py-2 text-sm font-semibold text-white ring-1 ring-inset ring-gray-300 hover:bg-red-400 hover:text-white focus:z-10'}
                                        data-button={'setAttractionType'} data-key={'attractionType'}
                                        data-value={'music'}
                                        data-unique={true}
                                        data-remove={false} data-eventid={eventData['@id']}
                                        title={'Set as music event'}

                                    >
                                        <i className="fa-duotone fa-music" data-button={'setAttractionType'}
                                           data-key={'attractionType'}
                                           data-value={'music'}
                                           data-unique={true}
                                           data-remove={false} data-eventid={eventData['@id']}></i>
                                    </button>
                                </>)}
                                    {!eventData.gogo || !eventData.gogo.majorType && (<>
                                        <button
                                            type="button"
                                            className={'relative -ml-px rounded inline-flex items-center bg-green-700 px-3 py-2 text-sm font-semibold text-white ring-1 ring-inset ring-gray-300 hover:bg-red-400 hover:text-white focus:z-10'}
                                            data-button={'setAttractionType'} data-key={'attractionType'}
                                            data-value={'music'}
                                            data-unique={true}
                                            data-remove={false} data-eventid={eventData['@id']}
                                            title={'Set as music event'}

                                        >
                                            <i className="fa-duotone fa-music" data-button={'setAttractionType'}
                                               data-key={'attractionType'}
                                               data-value={'music'}
                                               data-unique={true}
                                               data-remove={false} data-eventid={eventData['@id']}></i>
                                        </button>
                                    </>)}
                                </span>
                                                    </div>

                                                </div>
                                                <EventStatistics event={eventData}/>
                                                {eventData.description && <div className="mt-4"
                                                                               dangerouslySetInnerHTML={{__html: eventData.description}}></div>}


                                                <div className={'mt-4 isolate inline-flex rounded-md shadow-sm'}>
                                                    <button
                                                            className={'relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}
                                                            onClick={() => window.location.href = '/event/' + eventData['@id'] + '/merge'}
                                                    >Merge

                                                    </button>

                                                    <button onClick={() =>editDescriptions()}
                                                            className={'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}>
                                                        Descriptions
                                                    </button>
                                                    <button onClick={() => window.location.href = '/event/' + eventData['@id']+'/history'}
                                                            className={'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}>
                                                        Event History
                                                    </button>

                                                </div>


                                            </div>
                                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-3">

                                                <div className=" px-4 mt-8 sm:px-0 ">
                                                    {!wholeDay && <LocalizationProvider dateAdapter={AdapterMoment}
                                                                                        adapterLocale="en-gb">
                                                        <DateTimePicker
                                                                label="When?"
                                                                defaultValue={moment(eventData.localStartDate)}
                                                                ampm={false}
                                                                onChange={changeStartDate}
                                                        />
                                                    </LocalizationProvider>}
                                                    {wholeDay && <LocalizationProvider dateAdapter={AdapterMoment}
                                                                                       adapterLocale="en-gb">
                                                        <DatePicker
                                                                label="When?"
                                                                defaultValue={moment(eventData.localStartDate)}
                                                                onChange={changeStartDate}
                                                        />
                                                    </LocalizationProvider>}
                                                </div>
                                                <div className=" px-4 mt-8 sm:px-0 ">
                                                    {!wholeDay && <LocalizationProvider dateAdapter={AdapterMoment}
                                                                                        adapterLocale="en-gb">
                                                        <DateTimePicker
                                                                label="Until?"
                                                                defaultValue={moment(eventData.localEndDate)}
                                                                ampm={false}
                                                                onChange={changeEndDate}
                                                        />
                                                    </LocalizationProvider>}
                                                    {wholeDay && <LocalizationProvider dateAdapter={AdapterMoment}
                                                                                       adapterLocale="en-gb">
                                                        <DatePicker
                                                                label="Until?"
                                                                defaultValue={moment(eventData.localEndDate)}
                                                                onChange={changeEndDate}

                                                        />
                                                    </LocalizationProvider>}
                                                </div>
                                                <div className=" px-4 mt-8 sm:px-0 ">
                                                    {eventData && <Field as="div" className="flex items-center"><Switch
                                                            checked={wholeDay}
                                                            onChange={() => setWholeDay(!wholeDay)}
                                                            className={classNames(wholeDay ? 'bg-indigo-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2')}
                                                    >
                                                        <span className="sr-only"></span>
                                                        <span
                                                                aria-hidden="true"
                                                                className={classNames(wholeDay ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out')}
                                                        />
                                                    </Switch>
                                                        <Label as="span" className="ml-3 text-sm">
                                                            <span className="font-medium text-gray-900">Whole day event</span>
                                                        </Label>
                                                    </Field>}
                                                    {eventData &&
                                                     <Field as="div" className="flex items-center mt-2"><Switch
                                                             checked={isPrivate}
                                                             onChange={() => setIsPrivate(!isPrivate)}
                                                             className={classNames(isPrivate ? 'bg-indigo-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2')}
                                                     >
                                                         <span className="sr-only"></span>
                                                         <span
                                                                 aria-hidden="true"
                                                                 className={classNames(isPrivate ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out')}
                                                         />
                                                     </Switch>
                                                         <Label as="span" className="ml-3 text-sm">
                                                             <span className="font-medium text-gray-900">Private</span>
                                                         </Label>
                                                     </Field>}
                                                </div>

                                            </div>
                                            {eventData && eventData.location && eventData.location.address && eventData.location.address.timezone && <div
                                                    className="mt-1 text-gray-600 text-sm">{eventData.location.address.timezone}</div>}
                                            <div className={'mt-4'}>
                                                <select className={'text-gray-900 font-bold text-lg'}
                                                        onChange={(e) => changeType(e)}
                                                        value={eventData && eventData.gogo && eventData.gogo.majorType ? eventData.gogo.majorType : ''}>

                                                    <option value={''}>Type of event</option>
                                                    <option value={'arts'}>Arts</option>
                                                    <option value={'artsandcrafts'}>Arts and Crafts</option>
                                                    <option value={'burlesque'}>Burlesque / Drag</option>
                                                    <option value={'charity'}>Charity</option>
                                                    <option value={'community'}>Community</option>
                                                    <option value={'communityEntertainment'}>Community Entertainment
                                                    </option>
                                                    <option value={'conference'}>Conference</option>
                                                    <option value={'convention'}>Convention</option>
                                                    <option value={'educational'}>Educational</option>
                                                    <option value={'exercise'}>Exercise</option>
                                                    <option value={'exhibition'}>Exhibition</option>
                                                    <option value={'film'}>Film</option>
                                                    <option value={'foodspecials'}>Food specials</option>
                                                    <option value={'hospitality'}>Hospitality</option>
                                                    <option value={'karaoke'}>Karaoke</option>
                                                    <option value={'lecture'}>Lecture</option>
                                                    <option value={'localinterest'}>Local Interest</option>
                                                    <option value={'media'}>Media</option>
                                                    <option value={'meetup'}>Meetup</option>
                                                    <option value={'music'}>Music</option>
                                                    <option value={'nonprofit'}>Nonprofit organization</option>
                                                    <option value={'other'}>Other</option>
                                                    <option value={'outdoorsActivity'}>Outdoors Activity</option>
                                                    <option value={'parking'}>Parking</option>
                                                    <option value={'party'}>Party</option>
                                                    <option value={'politics'}>Politics</option>
                                                    <option value={'publicService'}>Public Service</option>
                                                    <option value={'publishingparty'}>Publishing Party</option>
                                                    <option value={'quizzes'}>Quizzes</option>
                                                    <option value={'reading'}>Reading</option>
                                                    <option value={'religion'}>Religion</option>
                                                    <option value={'shopping'}>Shopping</option>
                                                    <option value={'sports'}>Sports</option>
                                                    <option value={'standup'}>Standup</option>
                                                    <option value={'theater'}>Theater</option>
                                                    <option value={'tourist'}>Tourist Attractions</option>
                                                    <option value={'unknown'}>unknown</option>
                                                    <option value={'upsell'}>Upsell</option>
                                                    <option value={'wellness'}>Wellness</option>
                                                    <option value={'workshop'}>Workshop</option>
                                                </select>
                                            </div>
                                            <div className=" px-4 sm:mt-16 sm:px-0 lg:mt-4"
                                                 onClick={(event) => clickedEvent(event)}>
                                                {audienceButtons(eventData)}
                                            </div>
                                            <div className=" px-4 sm:mt-16 sm:px-0 lg:mt-4">
                                                <button className={'text-gray-900 font-bold text-lg'} onClick={() => searchVenues()}>Venue <small className={'text-pg_blue'}>change</small></button>
                                                {eventData.location && smallVenueCard(eventData.location)}
                                                {!eventData.location && <>
                                                    <div
                                                            className="mt-2 relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
                                                            onClick={() => searchVenues()}>


                                                        <div className="flex-shrink-0">

                                                        </div>
                                                        <div className="min-w-0 flex-1 pt-2 pb-2">
                                                            <a href="#" className="focus:outline-none">
                                                                    <span className="absolute inset-0"
                                                                          aria-hidden="true"
                                                                    />
                                                                <p className="text-sm font-medium text-gray-900">Set
                                                                    Venue</p>
                                                                <p className="truncate text-sm text-gray-500"></p>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </>}
                                            </div>
                                            <div className=" px-4 sm:mt-16 sm:px-0 lg:mt-0">
                                                <section aria-labelledby="details-heading" className="mt-12">

                                                    <div>

                                                        <button className="text-gray-900 font-bold text-lg"
                                                                onClick={() => setRemovingAttractions(!removingAttractions)}>{removingAttractions &&
                                                                                                                              <span>Remove</span>}{!removingAttractions &&
                                                                                                                                                   <span>View</span>} performers
                                                        </button>
                                                        <div
                                                                className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2"
                                                                onClick={(event) => clickedEvent(event)}>
                                                            {artists && artists.map((artist, index) => (<>
                                                                {workingWithCardPlusEdit(artist)}
                                                            </>))}
                                                            <div
                                                                    className="mt-2 relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
                                                                    onClick={() => searchAttractions()}>


                                                                <div className="flex-shrink-0">

                                                                </div>
                                                                <div className="min-w-0 flex-1 pt-2 pb-2 cursor-pointer">
                                                                    <div className="focus:outline-none">
                                                                    <span className="absolute inset-0"
                                                                          aria-hidden="true"
                                                                    />
                                                                        <p className="text-sm font-medium text-gray-900">Add
                                                                            attraction</p>
                                                                        <p className="truncate text-sm text-gray-500"></p>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                        </div>
                                                        <div className="mt-2">
                                                            <div className="mt-2">
                                                                <div className="mt-4">
                                                                    {eventData.url && <div className="mt-2 border-t border-b p-2">
                                                                     <a href={eventData.url} target="_blank">
                                                                         <button
                                                                                 type="button"
                                                                                 className="inline-flex items-center rounded-md bg-pg_green px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pg_pink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
                                                                         >
                                                                             View on {getSite(eventData.url)}
                                                                         </button>
                                                                     </a>{copyButton(eventData.url)}</div>}
                                                                    <div className={'mt-2'}>

                                                                        {eventData.offers && eventData.offers.length > 0 && eventData.offers.map((offer, index) => (<>
                                                                        <div key={index}>
                                                                        <form onSubmit={e => setPurchaseURL(e)}>
                                                                            <label htmlFor="value"
                                                                                   className="text-1xl font-bold tracking-tight text-gray-900">
                                                                                Purchase URL
                                                                            </label>
                                                                            <div className={'mt-2'}>
                                                                               <a href={offer.url} target={"_blank"}><span className={'text-sm text-pg_blue'}>{offer.price}{!offer.price && offer.minPrice} {offer.maxPrice && <> - {offer.maxPrice}</>} {offer.priceCurrency} @{offer.name}{!offer.name && getSite(offer.url)}</span></a> {copyButton(offer.url)}

                                                                            </div>
                                                                            <div className="mt-2 flex rounded-md shadow-sm h-10">
                                                                                <div
                                                                                    className="relative flex flex-grow items-stretch focus-within:z-10">
                                                                                    <div
                                                                                        className="p-2 pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">

                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="value"
                                                                                        id="value"
                                                                                        className="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-gray-900"
                                                                                        defaultValue={offer.url}
                                                                                    />
                                                                                </div>
                                                                                <button
                                                                                    type="submit"
                                                                                    className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                                                >

                                                                                    Save
                                                                                </button>
                                                                            </div>
                                                                        </form>
                                                                        </div>
                                                                        </>))}

                                                                        {eventData.offers && !eventData.offers.length &&  (<>
                                                                            <div >
                                                                                <form onSubmit={e => setPurchaseURL(e)}>
                                                                                    <label htmlFor="value"
                                                                                           className="text-1xl font-bold tracking-tight text-gray-900">
                                                                                        Purchase URL
                                                                                    </label>
                                                                                    <div className={'mt-2'}>
                                                                                    <a href={eventData.offers.url} target={"_blank"}>{eventData.offers.price && <span className={'text-sm text-pg_blue'}>{eventData.offers.price} {eventData.offers.priceCurrency} @{eventData.offers.name}{!eventData.offers.name && getSite(eventData.offers.url)}</span> }</a> {copyButton(eventData.offers.url)}
                                                                                    </div>
                                                                                    <div className="mt-2 flex rounded-md shadow-sm h-10">
                                                                                        <div
                                                                                            className="relative flex flex-grow items-stretch focus-within:z-10">
                                                                                            <div
                                                                                                className="p-2 pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                                                            </div>

                                                                                            <input
                                                                                                type="text"
                                                                                                name="value"
                                                                                                id="value"
                                                                                                className="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-gray-900"
                                                                                                defaultValue={eventData.offers.url}
                                                                                            />
                                                                                        </div>
                                                                                        <button
                                                                                            type="submit"
                                                                                            className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                                                        >

                                                                                            Save
                                                                                        </button>
                                                                                    </div>
                                                                                </form>
                                                                            </div>
                                                                        </>)}

                                                                        {eventData.offers && eventData.offers.url && <div className={'mt-2 border-t border-b p-2'}>
                                                                            {eventData.offers.price} {eventData.offers.lowPrice} {eventData.offers.highPrice && <>- </>}{eventData.offers.highPrice} {eventData.offers.priceCurrency} @ <a
                                                                                href={eventData.offers.url} target="_blank">
                                                                            <button
                                                                                    type="button"
                                                                                    className="inline-flex items-center rounded-md bg-pg_blue px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pg_green focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
                                                                            >
                                                                                {getSite(eventData.offers.url)}
                                                                            </button>
                                                                        </a>
                                                                        </div>}
                                                                        {!eventData.offers && <>
                                                                            <form onSubmit={e => setPurchaseURL(e)}>
                                                                                <label htmlFor="value"
                                                                                       className="text-1xl font-bold tracking-tight text-gray-900">
                                                                                    Purchase URL
                                                                                </label>

                                                                                <div className="mt-2 flex rounded-md shadow-sm h-10">
                                                                                    <div
                                                                                            className="relative flex flex-grow items-stretch focus-within:z-10">
                                                                                        <div
                                                                                                className="p-2 pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                                                        </div>

                                                                                        <input
                                                                                                type="text"
                                                                                                name="value"
                                                                                                id="value"
                                                                                                className="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-gray-900"
                                                                                                //defaultValue={eventData.offers.url}
                                                                                        />
                                                                                    </div>
                                                                                    <button
                                                                                            type="submit"
                                                                                            className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                                                    >

                                                                                        Save
                                                                                    </button>
                                                                                </div>
                                                                            </form>

                                                                        </>}
                                                                    </div>
                                                                    <div className={'mt-2'}>
                                                                        <a href={`${process.env.REACT_APP_API_URL}/go/promogogo/createmoment.do?event=` + eventData['@id']}
                                                                           target="_blank">
                                                                            <button
                                                                                    type="button"
                                                                                    className="inline-flex items-center rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
                                                                            >
                                                                                Edit event
                                                                            </button>
                                                                        </a>
                                                                        {/*<button
                                                                                type="button"
                                                                                className="inline-flex items-center rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
                                                                                onClick={(e) => createEvent(e)}>

                                                                            Save event
                                                                        </button>*/}
                                                                    </div>


                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </section>

                                            </div>
                                        </div>
                                    </div>
                                   {/* <PromoteEvent event={eventData}/>*/}
                                </>}
                            </div>
                        </div>
                        <div className="">

                            <div className="mt-4">
                                {canEdit && eventData && eventData.image && <><img
                                        src={'https://promogogo.com/cdn-cgi/image/width=1280,height=720,fit=cover/' + eventData.image}
                                        alt={eventData.name} title={'change image'}
                                        className="rounded-lg cursor-pointer" onClick={() => toggleMedia()}/></>}
                                {canEdit && eventData && !eventData.image &&
                                 <div className={'bg-gray-200 h-64 w-full rounded-lg cursor-pointer'}
                                      onClick={() => toggleMedia()}></div>}
                                <div>
                                    {canEdit && <input type={'url'}
                                           className={'block w-full rounded-none border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600  tracking-tight text-gray-900'}
                                           onBlur={handleImageURL}
                                           defaultValue={eventData && eventData.image}
                                    />}
                                </div>
                                {showMedia &&
                                 <div onClick={(event) => clickedEvent(event)}><MediaCollection wide={false}
                                                                                                target={'mediaSelected'}/>
                                 </div>}


                            </div>
                            {data.isAdmin && editRequests && editRequests.length > 0 &&
                             <div className=" px-4 mt-4 sm:px-0 mr-2" onClick={(event) => clickedEvent(event)}>
                                 <h5 className={'text-gray-900 font-bold text-sm'}>Edit requests</h5>
                                 {editRequests.map((editRequest, index) => (<>
                                     {editRequest.key} {editRequest.value} <button type={'button'} className={'                                                                                    className="inline-flex items-center rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"\n'}
                                                                                   onClick={() => handleEditPrivileges(editRequest.key,editRequest.value)}>Accept</button>
                                 </>))}
                             </div>}
                            {duplicates && duplicates.length > 1 &&
                             <div className=" px-4 mt-4 sm:px-0 mr-2" onClick={(event) => clickedEvent(event)}>
                                 <h5 className={'text-gray-900 font-bold text-sm'}>Possible duplicates</h5>
                                 {duplicates.map((event, index) => (<>
                                     {eventData && eventData['@id'] !== event['@id'] && mergeEventsCard(event, eventData)}
                                 </>))}
                             </div>}

                            {showSpecial && <PromoteEventSpecial event={eventData}/>}

                            {!showSpecial && <PromoteEvent event={eventData}/>}
                        </div>
                    </div>
                    </>}
                    </main>
            </div>
            <ToastContainer autoClose={800} theme={'dark'}/>

        </div>)
}
